export const AccordionLevel = {
  LEVEL1: '1',
  LEVEL2: '2',
  LEVEL3: '3',
  LEVEL4: '4',
  LEVEL5: '5'
};
export const AccordionLayout = {
  SMALL: 'small',
  NORMAL: 'normal'
};
export const AccordionColor = {
  MONO_100: 'mono_100',
  MONO_200: 'mono_200'
};